import React, { useEffect } from 'react'
import { first } from 'libraries/lodash'
import url from 'libraries/front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import { replaceUrl } from 'libraries/front-end-core/core/history'
import Title from 'components/legislation/Title'
import { expandCallback, selectCallback } from 'services/LegislationService'
import Copyright from 'pages/legislation/Copyright'
import SectionHeaderOverride from 'components/legislation/SectionHeader'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const Wrapper = ({
  actSections,
  setLegislationActNodes,
  act,
  editingId,
  group,
  publishedId,
  versions,
  publisher,
  flavour,
  actIdMap,
  highlight
}) => {
  useEffect(() => {
    actSections && actSections.nodes && setLegislationActNodes(actSections.nodes)
    return () => setLegislationActNodes(false)
  }, [actSections])

  useEffect(() => {
    const { isArchived } = first(group)
    if (isArchived && flavour !== 'archive') {
      const pageId = url(LEGISLATION, { path: act, editingId, flavour: 'archive' })
      replaceUrl(pageId)
    } else if (!isArchived && flavour === 'archive') {
      const pageId = url(LEGISLATION, { path: act, editingId, flavour: 'full' })
      replaceUrl(pageId)
    }
  }, [])

  const category = actIdMap && actIdMap.has(act) ? actIdMap.get(act).category : null

  const accordionProps = {
    aol: group[0].aols,
    title: category ? <Title title={category} /> : null,
    cxNames: {
      accordionContainer: 'bg-white pb8 mb6',
      groupHeader: {
        depthStyle: (depth) => {
          switch (depth) {
            case 2:
              return 'bg-suez-canal white b--suez-canal ie-min-height-flex-items-center-fix hover-underline'
            default:
              return 'bg-powder-white b--eastern-breeze hover-underline'
          }
        },
        iconDepthStyle: depth => {
          switch (depth) {
            case 2:
              return 'white'
            default:
              return 'black o-80'
          }
        }
      },
      contentHeader: {
        borderColor: 'b--eastern-breeze'
      },
      content: {
        divider: 'bt--eastern-breeze'
      },
      borderColor: 'b--eastern-breeze'
    },
    group,
    eventCategory: 'Legislation',
    selectCallback,
    expandCallback,
    copyright: <Copyright />,
    SectionHeaderOverride,
    styleTitle: false,
    highlight
  }

  return <AccordionWrapperContainer {...accordionProps} />
}

export default Wrapper
